import { SetPlayingRecommendation } from "../components/recommendations/recommendationTypes";
import { trackEvent } from "../helpers/analyticsHelpers";
import { Recommendation } from "../service/areena-recommendations";
import { PlayerUpdateEvent } from "../types/public";

import { getRecommendationUrl } from "./areenaLinks";

const trackRecommendationLink = (
  programId: string,
  index: number,
  mainRecommendation = false
) =>
  trackEvent("player.recommendation.play", {
    yle_referrer: `player-recommendation|${programId}|place_${
      mainRecommendation ? "main" : index + 1
    }`
  });

export const playRecommendation = ({
  index,
  language,
  mainRecommendation = false,
  playProgram,
  programId,
  recommendation,
  setPlayingRecommendation,
  update
}: {
  index: number;
  language: string;
  mainRecommendation?: boolean;
  playProgram: boolean;
  programId: string;
  recommendation: Recommendation;
  setPlayingRecommendation: SetPlayingRecommendation;
  update: PlayerUpdateEvent;
}) => {
  trackRecommendationLink(programId, index, mainRecommendation);
  if (playProgram) {
    setPlayingRecommendation(index);
    update({
      autoplay: true,
      programId: recommendation.id
    });
  } else {
    window.location.assign(
      getRecommendationUrl({
        index,
        language,
        programId: recommendation.id
      })
    );
  }
};
